/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { Avatar, Checkbox, FormControlLabel, Grid, Typography } from '@mui/material'
import { FnBlock_UI } from 'service/SystemFunction/SystemFunction';
import { GridColumns } from '@mui/x-data-grid-pro';
import InnerHeadRoutes from 'components/Common/InnerHeadRoutes/InnerHeadRoutes';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { useLocation, useNavigate } from 'react-router-dom';
import Accordion from 'components/Common/Accordion/Accordion';
import InputFormItem from 'components/Common/ElementInForm/InputFormItem';
// yup
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from 'components/Common/FormItem/yup/yupFormSchemas';
import { AlertTitleTh, AxiosGet, AxiosPost, ResultAPI } from 'service/CommonFunction/TS_function';
import AutoCompleteSelect from 'components/Common/ElementInForm/AutoCompleteSelect';
import MultiSelectForm from 'components/Common/ElementInForm/MultiSelectForm';
import RadioFormItem from 'components/Common/ElementInForm/RadioFormItem';
import AsyncAutoComplete from 'components/Common/ElementInForm/AsyncAutoComplete';
import { BtnBack, BtnConfirm, BtnReject, BtnSave, BtnSend, BtnWaiting } from 'components/Common/Button';
import ContentWrapper from 'components/Common/style/ContentWrapper';
import { SwAlert } from 'components/Common/Alert/AlertForm';
import { SnackbarCustom } from 'components/Common/Alert/Snackbars/Snackbar';
import moment from 'moment';

import UserAvatar from "../../../../assets/Image/user-avatar.png";
import { currentLanguage } from 'service/CommonFunction/AxiosConfig';
import CheckboxItem from 'components/Common/NoFormItem/CheckboxItem';
import ModalRejectUser from 'view/BackEnd/ActivateUser/ModalRejectUser';
import {
    DataGridMui as Table,
    initRows,
    PaginationInterface,
} from "components/Common/Table/DataGridMui";

const OptionStatus = [
    { value: "1", label: "ใช้งาน" },
    { value: "0", label: "ไม่ใช้งาน" },
]

const CustomerForm = () => {

    const { BlockUI, UnBlockUI } = FnBlock_UI();
    const location = useLocation();
    const navigate = useNavigate();
    const sEditUserID = location.state ? location.state["sID"] : null;
    const [IsAddTel, setIsAddTel] = useState(false)
    const [IsAddTelExtention, setIsAddTelExtention] = useState(false)
    const [IsActivateByUser, setIsActivateByUser] = useState(true)
    const [IsActivateByAdmin, setIsActivateByAdmin] = useState(true)
    const [IsResendEmail, setIsResendEmail] = useState(false)
    const [IsOpenReject, setIsOpenReject] = useState(false)
    const [dCreate, setdCreate] = useState(null)
    const [dLastLogin, setdLastLogin] = useState(null)
    const [oOptionAddr, setOptionAddr] = useState([])
    const [userImg, setUserImage] = useState(null);

    const [lstAddr, setLstAddr] = useState(null)
    const [sSoldTo, setSoldTo] = useState(null)
    const [sShipTo, setShipTo] = useState(null)

    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "dAction",
        sSortDirection: "desc"
    });

    //SnankBar
    const [IsOpenSnackbar, setIsOpenSnackbar] = useState(false)
    const [sSeveritySnackbar, setsSeveritySnackbar] = useState("success")
    const [sMessageSnackbar, setsMessageSnackbar] = useState(null) as any

    const [Option, setOption] = useState({
        lstTitle: [],
        lstCompany: [],
        lstAddress: [],
        lstTel: [],
        lstBA: [],
    })

    const dataColumn: GridColumns = [
        {
            field: "nRow",
            headerName: "ที่",
            headerAlign: "center",
            width: 50,
            editable: false,
            resizable: false,
            disableReorder: true,
            align: "center",
            sortable: false,
        },
        {
            field: "dAction",
            headerName: "วันที่ดำเนินการ",
            headerAlign: "center",
            flex: 3,
            align: "center",
            resizable: true,
            disableReorder: true,
            minWidth: 100,
            sortable: false,
            renderCell: (item) => {
                let textdate = item.value != null ? moment(item.value).add(543, 'year').format("DD/MM/YYYY HH:mm น.") + "" : null;

                return (
                    <Typography component={"label"} style={{ textAlign: 'center' }}>{textdate} </Typography>
                );
            },
        },
        {
            field: "sStatus",
            headerName: "สถานะ",
            headerAlign: "center",
            flex: 2,
            align: "center",
            resizable: true,
            disableReorder: true,
            minWidth: 100,
            sortable: false
        },
        {
            field: "sRemark",
            headerName: "หมายเหตุ",
            headerAlign: "center",
            flex: 2,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 100,
            sortable: false
        }
    ];

    //#region  Form
    let objSchema = {
        sTitle: yupFormSchemas.object("คำนำหน้า", { required: true }),
        sFName: yupFormSchemas.string("ชื่อ", { required: true }),
        sLName: yupFormSchemas.string("นามสกุล", { required: true }),
        arrCompany: yupFormSchemas.stringArray("บริษัท", { required: true }),
        arrAddress: yupFormSchemas.stringArray("ที่อยู่", { required: true }),
        oTel: yupFormSchemas.object("หมายเลขโทรศัพท์", { required: true }),
        sEmail: yupFormSchemas.string("อีเมล", { required: true }),
        oOwnerPTT: yupFormSchemas.object("พนักงาน ปตท. ที่ดูแล", { required: true }),
        arrBA: yupFormSchemas.stringArray("กลุ่มตลาด", { required: false }),
        oStatus: yupFormSchemas.string("สถานะ", { required: true }),
        sInputTel: yupFormSchemas.string("หมายเลขโทรศัพท์", { required: IsAddTel, max: 10, matches: /^[0-9]{0,10}$/, labelmatches: 'กรุณากรอกข้อมูลเฉพาะตัวเลข' }),
        sInputTelExtension: yupFormSchemas.string("เบอร์ต่อ", { required: IsAddTelExtention, max: 10, matches: /^[0-9]{0,10}$/, labelmatches: 'กรุณากรอกข้อมูลเฉพาะตัวเลข' }),
    }

    const schema = yup.object().shape(objSchema);
    const form = useForm({
        resolver: yupResolver(schema),
        mode: 'all',
        shouldFocusError: true,
    })
    //#endregion

    useEffect(() => {
        GetInitialOption()

    }, []);

    const GetInitialOption = async () => {
        BlockUI();
        form.setValue("oStatus", "1");

        let oOptionVOC = {
            lstTitle: [],
            lstCompany: [],
            lstAddress: [],
            lstTel: [],
            lstBA: [],
        };

        await AxiosGet(`MasterData/GetMasterData`, { "nMasterTypeID": 1 }, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstTitle: res.result?.data || [] }
            })
        });

        await AxiosGet(`BAService/GetBA`, { "IsSuggestion": false }, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstBA: res.result?.data || [] }
                // form.setValue("arrBA", res.result?.data)
            })
        });

        await AxiosPost(`Company/SearchCompany`, { "nBAID": null, "sLanguage": "th", "IsAdd": false }, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstCompany: res.result?.data || [] }
                // form.setValue("arrCompany", res.result?.data)
            })
        });

        await AxiosGet(`User/GetUserTel`, { "sUserID": sEditUserID, "sLanguage": "th", "IsAdd": true }, (res) => {
            ResultAPI(res, null, () => {
                oOptionVOC = { ...oOptionVOC, lstTel: res.result?.data || [] }
                // form.setValue("sTelID", res.result?.data)
            })
        });

        await AxiosPost(`Company/GetCompanyAddressByID`, { "nCompanyID": [] }, (res) => {
            ResultAPI(res, null, () => {
                setOptionAddr(res.result?.data || [])
            })
        });

        await onSetOption(oOptionVOC);
        GetData()
        UnBlockUI()
    }

    const onActivated = () => {

        let data = {
            IsActive: form.getValues("oStatus") === "1" ? true : false,
            sUserID: sEditUserID,
            sSaleRepCode: form.getValues("oOwnerPTT") != null ? form.getValues("oOwnerPTT").value : null,
        }

        let sMessage = "คุณต้องการที่จะ Activate User นี้ใช่หรือไม่ ?"

        SwAlert.Confirm(AlertTitleTh.Confirm, sMessage, () => {
            BlockUI();
            AxiosPost(`User/ActivatedUser`, data, (res) => {
                ResultAPI(res, null, () => {
                    if (res.statusCode === 200 && res.Message === null) {
                        setIsOpenSnackbar(true);
                        setsMessageSnackbar("บันทึกข้อมูลสำเร็จ")
                        setsSeveritySnackbar("success")
                        setTimeout(() => {
                            UnBlockUI();
                            navigate("/Backend/Admin/CustomerList")
                        }, 2000)
                    } else {
                        setIsOpenSnackbar(true);
                        setsMessageSnackbar(res.Message)
                        setsSeveritySnackbar("warning")
                        UnBlockUI();
                    }
                })
            });
        })

    }

    const GetData = async () => {

        if (sEditUserID != null) {
            BlockUI()

            await AxiosGet(`Customer/GetDataCustomer`, { "sUserID": sEditUserID }, (res) => {
                UnBlockUI()
                ResultAPI(res, null, () => {
                    form.setValue("sTitle", res.oTitle || []);
                    form.setValue("oTel", res.oDefaultTel || []);
                    form.setValue("sFName", res.sFname);
                    form.setValue("sLName", res.sLname);
                    form.setValue("sEmail", res.sEmail);
                    form.setValue("arrBA", res.arrBA || []);
                    form.setValue("arrCompany", res.arrCompany || []);
                    form.setValue("oStatus", (res.IsActivateByUser && !res.IsActivateByAdmin) ? "1" : res.sStatus || "1");

                    if (res.oEmployee.value != null) {
                        form.setValue("oOwnerPTT", res.oEmployee || [])
                    }

                    if (res.arrCompany != null) {
                        var addr = {
                            "nCompanyID": res.arrCompany || []
                        }

                        AxiosPost(`Company/GetCompanyAddressByID`, addr, (res) => {
                            ResultAPI(res, null, () => {
                                setOptionAddr(res.result?.data || [])

                            })
                        });
                    }

                    setdCreate(res.dCreate)
                    setdLastLogin(res.dLastLogin)
                    setIsActivateByUser(res.IsActivateByUser)
                    setIsActivateByAdmin(res.IsActivateByAdmin)
                    setIsResendEmail(res.IsResendEmail)

                    if (res?.sPathImage) {
                        const img = new Image()
                        img.src = res.sPathImage
                        var result = new Promise((resolve) => {
                            img.onload = () => resolve(true);
                            img.onerror = () => resolve(false);
                        });
                        result.then(reustItem => {
                            var img = reustItem ? res.sPathImage : UserAvatar
                            setUserImage(img)
                        })
                    } else {
                        setUserImage(UserAvatar)
                    }

                    form.setValue("arrAddress", res.arrAddress || []);
                    setLstAddr(form.getValues("arrAddress"));

                    //history log
                    if (res.lstLogRegister) {
                        setDataRow({
                            ...dataRow,
                            arrRows: res.lstLogRegister || [],
                            nDataLength: res.lstLogRegister.length,
                            nPageIndex: 0,
                        });
                    }
                })
            });
        }

    }

    const onChangeCompany = () => {

        var lstAddrOld = form.getValues("arrAddress") || [];
        form.setValue("arrAddress", []);

        AxiosPost(`Company/GetCompanyAddressByID`, { "nCompanyID": form.getValues("arrCompany") || [] }, (res) => {
            ResultAPI(res, null, () => {
                setOptionAddr(res.result?.data || [])

                const lstAddrNew = res.result?.data.filter(item => lstAddrOld.includes(item.value));
                var result = lstAddrNew.map(m => {
                    return m.value
                })
                form.setValue("arrAddress", result || []);
                setLstAddr(form.getValues("arrAddress"));
            })
        });
    }

    const onSetOption = async (paramOption) => {
        setOption(paramOption)
    }

    const onSubmit = () => {
        let sMessage = "คุณต้องการที่จะบันทึกข้อมูลใช่หรือไม่ ?"
        SwAlert.Confirm(AlertTitleTh.Confirm, sMessage, () => {
            BlockUI();

            let objData = {
                sUserID: sEditUserID === null ? "" : sEditUserID,
                arrCompany: form.getValues("arrCompany"),
                arrAddress: form.getValues("arrAddress"),
                // arrBA: form.getValues("arrBA"),
                sTelID: form.getValues("oTel") != null ? form.getValues("oTel").value : null,
                sTitleID: form.getValues("sTitle") != null ? form.getValues("sTitle").value : null,
                sFName: form.getValues("sFName"),
                sLName: form.getValues("sLName"),
                sEmail: form.getValues("sEmail"),
                sSaleRepCode: form.getValues("oOwnerPTT") != null ? form.getValues("oOwnerPTT").value : null,
                sStatusID: form.getValues("oStatus"),
                sInputTel: form.getValues("sInputTel"),
                sInputTelExtension: form.getValues("sInputTelExtension")
            }

            AxiosPost("Customer/onSaveCustomer", objData, (result) => {

                ResultAPI(result, "Saved successfully.", () => {

                    if (result.statusCode == "200") {
                        setIsOpenSnackbar(true);
                        setsMessageSnackbar("บันทึกข้อมูลสำเร็จ")
                        setsSeveritySnackbar("success")
                        setTimeout(() => {
                            UnBlockUI();
                            navigate(`/Backend/Admin/CustomerList`)
                        }, 2000);

                    } else {
                        setIsOpenSnackbar(true);
                        setsMessageSnackbar(result.Message)
                        setsSeveritySnackbar("warning")
                        UnBlockUI();
                    }
                });
            }, (err) => {
                setIsOpenSnackbar(true);
                setsMessageSnackbar(err.response.data.Message)
                setsSeveritySnackbar("warning")
                UnBlockUI();
            });
        });
    }

    const onResend = () => {
        let sMessage = "คุณต้องการที่จะส่งอีเมลแจ้งเตือนใหม่อีกครั้งหรือไม่ ?"
        SwAlert.Confirm(AlertTitleTh.Confirm, sMessage, () => {
            BlockUI();
            AxiosPost("Customer/resendPassword", { sUserID: sEditUserID === null ? "" : sEditUserID }, (result) => {

                ResultAPI(result, "Re-send Email successfully.", () => {

                    if (result.statusCode == "200") {
                        setIsOpenSnackbar(true);
                        setsMessageSnackbar("ส่งอีเมลแจ้งเตือนใหม่อีกครั้งสำเร็จ")
                        setsSeveritySnackbar("success")
                        GetData();
                        UnBlockUI();

                    } else {
                        setIsOpenSnackbar(true);
                        setsMessageSnackbar(result.Message)
                        setsSeveritySnackbar("warning")
                        UnBlockUI();
                    }
                });
            }, (err) => {
                setIsOpenSnackbar(true);
                setsMessageSnackbar(err.response.data.Message)
                setsSeveritySnackbar("warning")
                UnBlockUI();
                // if (!err.response) {
                //     //history("/error", {replace: true})
                //     return;
                // }
            });
        });
    }

    return (
        <>
            <InnerHeadRoutes
                iconMUI={<ManageAccountsIcon style={{ fontSize: '1.5em' }} />}
                labal_Head="ผู้ดูแลระบบ"
                label_nameRoute="จัดการข้อมูลลูกค้า"
            />
            <FormProvider {...form}>
                <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start" style={{ marginTop: '0' }}>
                    <Grid item container xs={12} spacing={2}>
                        <Grid item xs={12} sm={8}>
                            <Accordion header={"ข้อมูลลูกค้า"}>
                                <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start" >
                                    <Grid item xs={12} sm={4} md={2}>
                                        <AutoCompleteSelect
                                            name="sTitle"
                                            options={Option.lstTitle || []}
                                            label={"คำนำหน้า"}
                                            required={true}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={5}>
                                        <InputFormItem
                                            id="sFName"
                                            name="sFName"
                                            label="ชื่อ"
                                            required={true}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={5}>
                                        <InputFormItem
                                            id="sLName"
                                            name="sLName"
                                            label="นามสกุล"
                                            required={true}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={12} >
                                        <MultiSelectForm
                                            name="arrCompany"
                                            options={Option.lstCompany || []}
                                            label={"บริษัท"}
                                            required={true}
                                            onChange={() => onChangeCompany()}
                                        />
                                    </Grid>
                                    <Grid item xs={12} >
                                        <MultiSelectForm
                                            name="arrAddress"
                                            options={oOptionAddr || []}
                                            label={"ที่อยู่"}
                                            required={true}
                                            onChange={(e) => {
                                                setLstAddr(form.getValues("arrAddress"));
                                                form.setValue("oOwnerPTT", null);
                                            }}
                                        />
                                    </Grid>
                                    {!IsAddTel &&
                                        <Grid item xs={12} sm={6}>
                                            <AutoCompleteSelect
                                                name="oTel"
                                                options={Option.lstTel || []}
                                                label={"หมายเลขโทรศัพท์"}
                                                required={true}
                                                onChange={() => form.getValues("oTel") && form.getValues("oTel").value === "-1" ? setIsAddTel(true) : setIsAddTel(false)}
                                            />
                                        </Grid>
                                    }
                                    {IsAddTel &&
                                        <>
                                            <Grid item xs={12} sm={4}>
                                                <AutoCompleteSelect
                                                    name="oTel"
                                                    options={Option.lstTel || []}
                                                    label={"หมายเลขโทรศัพท์"}
                                                    required={true}
                                                    onChange={() => form.getValues("oTel") && form.getValues("oTel").value === "-1" ? setIsAddTel(true) : setIsAddTel(false)}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <InputFormItem
                                                    id="sInputTel"
                                                    name="sInputTel"
                                                    label="หมายเลขโทรศัพท์"
                                                    required={true}
                                                    fullWidth
                                                    maxLength={10}
                                                    onChange={(e) => {
                                                        if (e == "") {
                                                            setIsAddTelExtention(false);
                                                        }
                                                    }}
                                                />
                                            </Grid>
                                            {<Grid item xs={6} sm={2}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={IsAddTelExtention}
                                                            disabled={(!form.getValues("sInputTel"))}
                                                            onChange={() => {
                                                                setIsAddTelExtention(!IsAddTelExtention);
                                                                form.setValue("sInputTelExtension", null)
                                                                form.clearErrors("sInputTelExtension")
                                                            }}
                                                        />
                                                    }
                                                    label="เบอร์ต่อ"
                                                    labelPlacement="end"
                                                />
                                            </Grid>}
                                            {IsAddTelExtention &&
                                                <Grid item xs={6} sm={2}>
                                                    <InputFormItem
                                                        id="sInputTelExtension"
                                                        name="sInputTelExtension"
                                                        label="เบอร์ต่อ"
                                                        required={true}
                                                        fullWidth
                                                        maxLength={10}
                                                    />
                                                </Grid>
                                            }
                                        </>
                                    }
                                    <Grid item xs={12} sm={IsAddTel ? 12 : 6}>
                                        <InputFormItem
                                            id="sEmail"
                                            name="sEmail"
                                            label="อีเมล"
                                            required={true}
                                            disabled={sEditUserID != null ? true : false}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        {/* <AsyncAutoComplete
                                        name="oOwnerPTT"
                                        sUrlAPI={"User/SearchEmpPIS"}
                                        label={"พนักงาน ปตท. ที่ดูแล"}
                                        required={true}
                                        textSearch={"กรอกรหัสพนักงาน/ชื่อ/นามสกุล"}
                                    /> */}
                                        <AsyncAutoComplete
                                            name="oOwnerPTT"
                                            sUrlAPI={"User/SearchEmpPISByAddress"}
                                            ParamUrl={{ "lstAddrID": lstAddr }}
                                            label={"พนักงาน ปตท. ที่ดูแล"}
                                            sMethodAxios={"POST"}
                                            required={true}
                                            textSearch={"กรอกรหัสพนักงาน/ชื่อ/นามสกุล"}
                                        />
                                    </Grid>
                                    {/* <Grid item xs={12}>
                                    <MultiSelectForm
                                        name="arrBA"
                                        options={Option.lstBA || []}
                                        label={"กลุ่มตลาด"}
                                        required={true}
                                    />
                                </Grid> */}
                                    <Grid item xs={12}>
                                        <RadioFormItem
                                            name="oStatus"
                                            label="สถานะ"
                                            required={true}
                                            options={OptionStatus}
                                            value={form.getValues("oStatus")}
                                            row={true}
                                            IsNewLine={false}
                                        />
                                    </Grid>
                                </Grid>
                            </Accordion>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <div
                                style={{
                                    width: '100%',
                                    border: '1px solid #d5d5d5 !important',
                                    padding: '16px',
                                    borderRadius: '10px',
                                    backgroundColor: '#fff',
                                    height: '100%'
                                }}
                            >
                                <Grid container spacing={3} justifyContent="center" alignItems="center">
                                    <Grid item xs={12}>
                                        <Avatar src={userImg ?? ""} style={{ width: '9em', height: '9em', margin: '0 auto' }} />
                                    </Grid>
                                    <Grid item xs={12} style={{ textAlign: 'center' }}>
                                        <Typography>ชื่อผู้ใช้งาน: {form.getValues("sFName") + " " + form.getValues("sLName")}</Typography>
                                        <Typography>วันที่ลงทะเบียน: {dCreate != null ? moment(dCreate).add(543, 'year').format("DD/MM/YYYY HH:mm น.") + "" : ""}</Typography>
                                        {IsActivateByAdmin &&
                                            <Typography>เข้าใช้งานล่าสุด: {dLastLogin != null ? moment(dLastLogin).add(543, 'year').format("DD/MM/YYYY HH:mm น.") + "" : "-"}</Typography>
                                        }
                                    </Grid>
                                    {!IsActivateByUser &&
                                        <Grid item xs={12}>
                                            <Grid container justifyContent="center" alignItems="center">
                                                <Grid item>
                                                    <BtnWaiting txt="Waiting User Activate" isDisabled={true} />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    }
                                    {(!IsActivateByAdmin && IsActivateByUser) &&
                                        <>
                                            <Grid item xs={6}>
                                                <Grid container justifyContent="center" alignItems="center">
                                                    <Grid item>
                                                        <BtnSave txt="Activate" onClick={() => { onActivated() }} />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Grid container justifyContent="center" alignItems="center">
                                                    <Grid item>
                                                        <BtnReject txt="Reject" onClick={() => { setIsOpenReject(true); }} />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </>
                                    }

                                    {/* re-send email */}
                                    {IsResendEmail &&
                                        <Grid item xs={12}>
                                            <Grid container justifyContent="center" alignItems="center">
                                                <Grid item>
                                                    <BtnSend txt="Re-send Email" onClick={(e) => onResend()} />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    }

                                </Grid>
                            </div>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Accordion header={"History Log"}>
                            <Table
                                Rows={dataRow}
                                HiddenToolHead={true}
                                Columns={dataColumn}
                                backgroundHeaderCustom={"#004290"}
                                sxCustomHeader={{ color: '#ffffff' }}
                                isNotShowPagination={true}
                            />
                        </Accordion>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={1} justifyContent="center" alignItems="center">
                            {IsActivateByUser && <Grid item>
                                <BtnConfirm txt='บันทึก' onClick={form.handleSubmit(() => { onSubmit() })} />
                            </Grid>
                            }
                            <Grid item>
                                <BtnBack onClick={() => navigate(`/Backend/Admin/CustomerList`)} />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </FormProvider>
            <ModalRejectUser
                IsOpen={IsOpenReject}
                setIsOpen={setIsOpenReject}
                sUserID={sEditUserID}
                sRedirect={"/Backend/Admin/CustomerList"}
                setIsOpenSnackbar={setIsOpenSnackbar}
                setsSeveritySnackbar={setsSeveritySnackbar}
                setsMessageSnackbar={setsMessageSnackbar}
            />
            <SnackbarCustom
                IsOpen={IsOpenSnackbar}
                Severity={sSeveritySnackbar}
                OnClose={() => { setIsOpenSnackbar(false) }}
                Message={sMessageSnackbar}
            />
        </>
    )
}

export default CustomerForm